import { SectionHeading } from './SectionHeading'

// "Contact Us" — email + hours (#7r2). Marketing has no phone, no
// address, no form. Email is a mailto link for one-click compose.

export function ContactSection() {
  return (
    <section id="contact" className="py-12 sm:py-16 px-4">
      <div className="max-w-2xl mx-auto text-center">
        <SectionHeading>Contact Us</SectionHeading>
        <div className="mt-8 space-y-2">
          <p className="text-white text-base sm:text-lg">
            <span className="mr-1" aria-hidden="true">📧</span>
            <a href="mailto:support@jnati.com" className="text-white hover:text-gold underline-offset-4 hover:underline transition-colors">
              support@jnati.com
            </a>
          </p>
          <p className="text-white/80 text-sm">Mon–Fri: 9:00 AM – 6:00 PM IST</p>
        </div>
      </div>
    </section>
  )
}
